module.exports = __webpack_public_path__ + "img/desk.7be518d8.jpg";